import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
    Box,
  CircularProgress,
  Alert
} from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import userApi from '../../api/userApi';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function ResetPasswordPage() {

  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);
  const [executing, setExecuting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr(null);

    if (password !== confirm) {
      setErr('Le password non coincidono');
      return;
    }

    try {
      setExecuting(true);
      await userApi.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      setErr(extractErrorMessage(e));
    }finally {
           setExecuting(false);
    }
  };

  if (!token) {
    return (
      <Container maxWidth="xs" sx={{ mt: 10 }}>
        <Alert severity="error">Token mancante</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Nuova password
        </Typography>
      {executing && (
        <Box
          sx={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            bgcolor: 'rgba(255,255,255,0.7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </Box>
      )}
        {done ? (
          <Alert severity="success">
            Password aggiornata. Reindirizzamento...
          </Alert>
        ) : (
          <form onSubmit={submit}>
            {err && <Alert severity="error">{err}</Alert>}

            <TextField
              fullWidth
              label="Nuova password"
              type="password"
              sx={{ mt: 2 }}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />

            <TextField
              fullWidth
              label="Conferma password"
              type="password"
              sx={{ mt: 2 }}
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
            >
              Cambia password
            </Button>
          </form>
        )}
      </Paper>
    </Container>
  );
}